import Phaser from 'phaser'
import { Background } from '../base/background'
import { CYBER_SNAKES_ATLAS_FRAMES, CYBER_SNAKES_TEXTURE_KEYS } from './constants'

export class CyberSnakesBackground extends Background {
  constructor(scene: Phaser.Scene, x: number, y: number) {
    super(scene, x, y)
  }

  createBackground() {
    const background = this.scene.add.image(
      0,
      0,
      CYBER_SNAKES_TEXTURE_KEYS.ATLAS,
      CYBER_SNAKES_ATLAS_FRAMES.GRID_BACKGROUND,
    )
    this.add(background)
  }
}
